import { defineStore } from "pinia"
import { ref, type Ref } from "vue"
import { PurchaseSurchargePeriod } from "@/models/purchase-surcharge-period.model"

export const usePurchaseSurchargePeriodStore = defineStore("purchaseSurchargePeriodStore", () => {
  const purchaseSurchargePeriods: Ref<PurchaseSurchargePeriod[]> = ref([])

  return {
    purchaseSurchargePeriods
  }
})
